import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { WebsocketConnectionStatus } from '../../logic/websockets/WebsocketConnectionStatus'

export interface WebsocketConnection {
	status: WebsocketConnectionStatus
}

const initialState: WebsocketConnection = {
	status: WebsocketConnectionStatus.Disconnected,
}

export const websocketConnectionSlice = createSlice({
	name: 'WebsocketConnnection',
	initialState,
	reducers: {
		setConnectionStatus: (state, action: PayloadAction<WebsocketConnectionStatus>) => {
			state.status = action.payload
		},
	},
})

export const { setConnectionStatus } = websocketConnectionSlice.actions

export default websocketConnectionSlice.reducer
